import styled from "styled-components";

const sizeVariants = {
  small: "40px",
  medium: "48px",
  large: "56px",
};

export const SearchInputWrapper = styled.label<{
  $size?: "small" | "medium" | "large";
}>`
  display: flex;
  align-items: center;
  width: 100%;
  height: ${({ $size = "small" }) => sizeVariants[$size]};
  border-width: 2px;
  border-style: solid;
  border-radius: ${({ theme }) => theme.borderRadius.L};
  border-color: ${({ theme }) => theme.colors.stroke.lighterGrey};
  column-gap: ${({ theme }) => theme.spacers.M};
  padding: ${({ theme }) => `0 ${theme.spacers.M} 0 ${theme.spacers.L}`};
  transition: border-color 0.4s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    border-color: ${({ theme }) => theme.colors.stroke.baseGrey};
  }

  &:focus-within {
    border-color: ${({ theme }) => theme.colors.stroke.darkerGrey};
  }
`;

export const SearchInput = styled.input`
  font-size: 16px;
  width: 100%;
  border: none;
  outline: none;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.text.darkerGrey};
  background-color: ${({ theme }) => theme.colors.background.white};

  &::placeholder {
    font-weight: 500;
    color: ${({ theme }) => theme.colors.text.darkGrey};
    text-decoration: none;
  }

  &[type="search"]::-webkit-search-decoration,
  &[type="search"]::-webkit-search-cancel-button,
  &[type="search"]::-webkit-search-results-button,
  &[type="search"]::-webkit-search-results-decoration {
    -webkit-appearance:none;
  }
`;

export const SearchIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.text.darkerGrey};
`;
